import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { CostCenter, CostCenterListResponse, CostCenterQueryParams, CreateCostCenter, UpdateCostCenter } from '@frontend/cost-center/types';

export class CostCenterClient extends APIClient {
    public static readonly endpoint = '/cost-center-api/v1';

    public static async fetchCostCenters(
        queryParams?: ApiQueryParams<DefaultQueryParams & CostCenterQueryParams>,
        withCredentials?: Token
    ): Promise<CostCenterListResponse> {
        return await this.apiPaginated<CostCenterListResponse, DefaultQueryParams & CostCenterQueryParams>(
            `${this.endpoint}/cost-centers`,
            queryParams,
            withCredentials
        );
    }

    public static async resolveCostCenters(ids: string[], field: string = 'id'): Promise<CostCenterListResponse> {
        return this.resolve<CostCenterListResponse>(`${this.endpoint}/cost-centers`, ids, field);
    }

    public static async deleteCostCenters(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/cost-centers-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async fetchAccountCostCenters(accountId: string, queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<CostCenterListResponse> {
        return await this.apiPaginated<CostCenterListResponse, DefaultQueryParams>(`${this.endpoint}/accounts/${accountId}/cost-centers`, queryParams);
    }

    public static async postCostCenter(accountId: string, body: CreateCostCenter): Promise<CostCenter> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/cost-centers`, body);
        return await this.handleResponse<CostCenter>(response);
    }

    public static async fetchCostCenter(accountId: string, costCenterId: string): Promise<CostCenter> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/cost-centers/${costCenterId}`);
        return await this.handleResponse<CostCenter>(response);
    }

    public static async patchCostCenter(accountId: string, costCenterId: string, body: UpdateCostCenter) {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/cost-centers/${costCenterId}`, body);
        return await this.handleResponse<CostCenter>(response);
    }

    public static async deleteCostCenter(accountId: string, costCenterId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/cost-centers/${costCenterId}`);
        return await this.handleVoidResponse(response);
    }
}
